import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import { styled } from '@mui/system'
import useLogout from 'hooks/useLogout'
import { useReducerContext, ActionKind } from 'hooks/useReducerContext'

const MyButton = styled(Button)({
  width: 100,
  '@media only screen and (min-width: 500px)': {
    '& + &': {
      marginLeft: 30,
    },
  },
})

const DIALOG_TITLE = 'ログアウトしますか？'

function LogoutDialog() {
  const { loggingOut, logout } = useLogout()
  const [
    {
      logout: { open },
    },
    dispatch,
  ] = useReducerContext()

  const handleClose = () => {
    dispatch({ type: ActionKind.LOGOUT_CLOSE })
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent>
        <DialogContentText style={{ textAlign: 'center' }}>
          <b>{DIALOG_TITLE}</b>
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          '@media only screen and (min-width: 500px)': {
            px: 4,
            pb: 3,
          },
        }}
      >
        <MyButton
          variant="outlined"
          color="primary"
          onClick={handleClose}
          data-testid="cancel-button"
        >
          いいえ
        </MyButton>
        <MyButton
          variant="outlined"
          style={{ backgroundColor: '#FA5858', color: '#fff' }}
          onClick={logout}
          disabled={loggingOut}
          data-testid="action-button"
        >
          はい
        </MyButton>
      </DialogActions>
    </Dialog>
  )
}

export default LogoutDialog
